import { connect } from 'react-redux';
import { LeftNav as leftNav } from '../components/index';
import { setView, updateResourceSearchText } from '../actions';

const mapStateToProps = state => ({
  view: state.view,
});

const mapDispatchToProps = dispatch => (
  {
    setView: (view) => {
      dispatch(setView(view));
    },
    updateSearchText: ({ searchText }) => {
      dispatch(updateResourceSearchText({ searchText }));
    },
  }
);

const LeftNav = connect(
  mapStateToProps,
  mapDispatchToProps,
)(leftNav);

export default LeftNav;



// WEBPACK FOOTER //
// ./src/containers/LeftNav.js